import { productConstants } from "../constants";

const initialState = {
  loading: false,
  error: null,
  items: null,
};

export const QuestionsTypesData = (state = initialState, action) => {
  switch (action.type) {
    case productConstants.QUESTIONS_TYPES_REQUEST:
      return {
        ...state,
        loading: true,
        items: null,
        error: null,
      };
    case productConstants.QUESTIONS_TYPES_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload,
        error: null,
      };
    case productConstants.QUESTIONS_TYPES_FAILURE:
      return {
        ...state,
        loading: false,
        items: null,
        error: action.payload,
      };
    default:
      return state;
  }
};